import React, { useEffect, useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { Breadcrumb, Loader, Nav, Panel } from 'rsuite';
import PageHeader from '@/components/PageHeader';
import ScrapedEventForm from './scraped-event-form';
import { BaseErrorModel, BaseResponseModel, PageState } from '@/models/core.model';
import { AxiosError } from 'axios';
import { toastErrorMessage } from '@/utils/toasterMessage';
import { ScrapedEvent } from '@/models/scraped-event.model';
import { getScrapedEvent } from '@/services/scraped-event.service';
import ScrapedEventActions from './action/scraped-event-actions';

const CustomNav = ({ active, onSelect, newMode, ...props }) => {
  return (
    <Nav {...props} activeKey={active} onSelect={onSelect}>
      <Nav.Item eventKey="scraped-event-form">Scraped Event Detail</Nav.Item>
      <Nav.Item disabled={newMode} eventKey="scraped-event-actions">Actions</Nav.Item>
    </Nav>
  );
};

const Page = () => {

  const requestedTab = useLocation()?.state?.tab;

  const [activeTab, setActiveTab] = useState('scraped-event-form');
  const [formObject, setFormObject] = useState<ScrapedEvent|undefined>(undefined);
  const [loading, setLoading] = useState(false);

  const nav = useNavigate();

  const { id: idParam } = useParams();
  const id = idParam ? parseInt(idParam, 10) : undefined;
  const pageState = id ? PageState.Edit : PageState.New;


  useEffect(() => {
    if (pageState == PageState.Edit) {
      fetchData();
    } else {
      setFormObject(undefined);
    }
    setActiveTab(pre => requestedTab ?? pre);
  }, [id]);
  
  const fetchData = async () => {
    if (id) {
      setLoading(true);
      try {
        const result: BaseResponseModel<ScrapedEvent> = await getScrapedEvent(id);
        if (result.success) {
          setFormObject(result.result);
        }
      } catch (err) {
        const errorModel = (err as AxiosError<BaseErrorModel>).response?.data;
        toastErrorMessage(`Error in fetching Scraped Event: ${errorModel?.errorMessage}`);
        nav('scraped-events');
      }
      finally {
        setLoading(false);
      }
    }
  };
 
  return (
    <Panel
      header={
        <PageHeader title={`Scraped Event: ${formObject?.name}`}>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href='scraped-events'> Scraped Events</Breadcrumb.Item>
            <Breadcrumb.Item active>{formObject?.name}</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <CustomNav appearance="subtle" active={activeTab} onSelect={key => setActiveTab(key)} newMode={pageState == PageState.New} />
      {
        loading ? <Loader center content="loading ..." /> :
        <>
          {activeTab == 'scraped-event-form' && <ScrapedEventForm formObject={formObject} fetchData={fetchData}/>}
          {activeTab == 'scraped-event-actions' && <ScrapedEventActions formObject={formObject} fetchData={fetchData}/>}
        </>
      }
    </Panel>
  );
};

export default Page;
